import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "src/contexts/AuthContext";
import * as ROUTES from "src/constants/routes";


interface PrivateRouteProps {
  children: React.ReactNode;
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ children }) => {
  const { isAuthenticated } = useAuth();

  return isAuthenticated ? <>{children}</> : <Navigate to={ROUTES.LOGIN} replace />;
};

export default PrivateRoute;
